export const allowedCountries: string[] = [
  'AU',
  'AT',
  'BH',
  'BE',
  'BG',
  'CA',
  'CN',
  'HR',
  'CZ',
  'DK',
  'FI',
  'FR',
  'DE',
  'GR',
  'HK',
  'HU',
  'IT',
  'JP',
  'JO',
  'KW',
  'LU',
  'MY',
  'NL',
  'NO',
  'PL',
  'PT',
  'QA',
  'RO',
  'SA',
  'SG',
  'SK',
  'SI',
  'ZA',
  'ES',
  'SE',
  'CH',
  'TW',
  'TH',
  'AE',
  'GB',
  'US',
];
